import React from 'react';
import { render } from '@testing-library/react';
import { BreakPoint } from './BreakPoint';

describe('BreakPoint', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	it('should pass through data automation attributes', () => {
		const { container } = render(
			<BreakPoint max={2400} min={0} data-auto-sel="automation-selector">
				larger than 0 & smaller than 2400
			</BreakPoint>
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});
});
